(() => {
  "use strict";

  const PREVIEW_ID = "monello-beschriftung-preview";

  function findFieldByLabel(labelText) {
    const labels = Array.from(document.querySelectorAll("label"));

    const label = labels.find((item) =>
      item.textContent
        ?.trim()
        .toLowerCase()
        .includes(labelText.toLowerCase())
    );

    if (!label) return null;

    if (label.htmlFor) {
      const field = document.getElementById(label.htmlFor);
      if (field) return field;
    }

    return label.querySelector("input, textarea") ||
      label.parentElement?.querySelector("input, textarea") ||
      null;
  }

  function findField(names, fallbackIds = []) {
    for (const name of names) {
      const selectors = [
        `input[name="${CSS.escape(name)}"]`,
        `textarea[name="${CSS.escape(name)}"]`,
        `input[name*="${CSS.escape(name)}"]`,
        `textarea[name*="${CSS.escape(name)}"]`
      ];

      for (const selector of selectors) {
        const field = document.querySelector(selector);
        if (field) return field;
      }

      const labelField = findFieldByLabel(name);
      if (labelField) return labelField;
    }

    for (const id of fallbackIds) {
      const field = document.getElementById(id);
      if (field) return field;
    }

    return null;
  }

  function getFields() {
    return {
      name: findField(
        ["Name deines Tieres", "Name des Tieres", "Tiername"],
        ["text-3"]
      ),
      date: findField(
        ["Lebensdaten", "Geburts- und Sterbedatum"],
        ["text-5"]
      ),
      text: findField(
        ["Erinnerungstext", "Gedenktext", "Text"],
        ["text-6"]
      )
    };
  }

/* =========================================
   Zeichenzähler
========================================= */

function initCharacterCounter(textField) {

  if (!textField) return;

  if (document.getElementById("monello-char-counter")) return;

  const counter = document.createElement("div");

  counter.id = "monello-char-counter";
  counter.className = "monello-char-counter";

const fieldWrapper =
  textField.closest(".gpo-element") ||
  textField.parentElement;

fieldWrapper.appendChild(counter);

  function updateCounter() {

    const length = textField.value.trim().length;

    counter.textContent = `${length} / 30 Zeichen`;

    counter.classList.remove(
      "is-good",
      "is-warning",
      "is-danger"
    );

    if (length <= 25) {

      counter.classList.add("is-good");

    } else if (length <= 30) {

      counter.classList.add("is-warning");

    } else {

      counter.classList.add("is-danger");

    }

  }

  updateCounter();

  textField.addEventListener("input", updateCounter);

}

  function getPreviewElements() {
    return {
      preview: document.getElementById(PREVIEW_ID),
      empty: document.getElementById("mbp-empty"),
      name: document.getElementById("mbp-name"),
      date: document.getElementById("mbp-date"),
      symbols: document.getElementById("mbp-symbols"),
      text: document.getElementById("mbp-text"),
      card: document.querySelector(`#${PREVIEW_ID} .mbp-card`)
    };
  }

function getSelectedFontAndColorValues() {
  const groups = Array.from(
    document.querySelectorAll(".gpo-element")
  );

  const relevantGroups = groups.filter((group) => {
    const text = group.textContent?.toLowerCase() || "";

    return (
      text.includes("schriftart") ||
      text.includes("schriftfarbe")
    );
  });

  return relevantGroups.flatMap((group) => {
    return Array.from(
      group.querySelectorAll(
        "input:checked, select"
      )
    ).map((input) => {
      const label =
        input.id
          ? group.querySelector(
              `label[for="${CSS.escape(input.id)}"]`
            )
          : null;

      return [
        input.value || "",
        label?.textContent || "",
        input.selectedOptions?.[0]?.textContent || ""
      ]
        .join(" ")
        .trim();
    });
  });
}

  function detectFontAndColor() {
    const values = getSelectedFontAndColorValues();

    let font = "'Libre Baskerville', serif";
    let color = "#2f2520";

    for (const rawValue of values) {
      const value = rawValue.toLowerCase();

      if (value.includes("cinzel")) {
        font = "'Cinzel', serif";
      } else if (value.includes("cookie")) {
        font = "'Cookie', cursive";
      } else if (
        value.includes("greatvibes") ||
        value.includes("great vibes")
      ) {
        font = "'Great Vibes', cursive";
      } else if (value.includes("italianno")) {
        font = "'Italianno', cursive";
      } else if (value.includes("kaushan")) {
        font = "'Kaushan Script', cursive";
      } else if (value.includes("marck")) {
        font = "'Marck Script', cursive";
      } else if (value.includes("playfair")) {
        font = "'Playfair Display', serif";
      } else if (value.includes("marcellus")) {
        font = "'Marcellus', serif";
      } else if (value.includes("pacifico")) {
        font = "'Pacifico', cursive";
      } else if (value.includes("satisfy")) {
        font = "'Satisfy', cursive";
      } else if (value.includes("trajan")) {
        font = "'Trajan Pro', serif";
      } else if (value.includes("champagne")) {
        font = "'Champagne & Limousines', sans-serif";
      }

      if (value.includes("schwarz")) {
        color = "#2f2520";
      } else if (
        value.includes("weiß") ||
        value.includes("weiss")
      ) {
        color = "#ffffff";
      } else if (value.includes("roségold") || value.includes("rosegold")) {
        color = "#c58c80";
      } else if (value.includes("gold")) {
        color = "#c8a24a";
      } else if (value.includes("silber")) {
        color = "#b8b8b8";
      }
    }

    return { font, color };
  }
function getSelectedSymbols() {
  const selected = Array.from(
    document.querySelectorAll(
      '.gpo-element input[type="checkbox"]:checked'
    )
  );

  return selected
    .map((input) => {
      const label =
        input.closest("label") ||
        (input.id
          ? document.querySelector(
              `label[for="${CSS.escape(input.id)}"]`
            )
          : null);

      const image =
        label?.querySelector("img") ||
        input.closest(".gpo-element")?.querySelector(
          `label[for="${CSS.escape(input.id)}"] img`
        );

      if (image?.src) {
        return {
          type: "image",
          src: image.src,
          alt:
            image.alt ||
            input.value ||
            "Ausgewähltes Symbol"
        };
      }

      return null;
    })
    .filter(Boolean);
}
function hexToRgb(hex) {
  const normalized = hex.replace("#", "");

  return {
    r: parseInt(normalized.substring(0, 2), 16),
    g: parseInt(normalized.substring(2, 4), 16),
    b: parseInt(normalized.substring(4, 6), 16)
  };
}

function createColoredSymbol(symbol, color) {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  const sourceImage = new Image();

  canvas.className = "mbp-symbol-image";
  canvas.width = 100;
  canvas.height = 100;
  canvas.setAttribute("role", "img");
  canvas.setAttribute("aria-label", symbol.alt);

  sourceImage.crossOrigin = "anonymous";
  sourceImage.src = symbol.src;

  sourceImage.onload = function () {
    if (!context) return;

    context.clearRect(0, 0, canvas.width, canvas.height);

    const scale = Math.min(
      canvas.width / sourceImage.naturalWidth,
      canvas.height / sourceImage.naturalHeight
    );

    const width = sourceImage.naturalWidth * scale;
    const height = sourceImage.naturalHeight * scale;
    const x = (canvas.width - width) / 2;
    const y = (canvas.height - height) / 2;

    context.drawImage(sourceImage, x, y, width, height);

    const imageData = context.getImageData(
      0,
      0,
      canvas.width,
      canvas.height
    );

    const pixels = imageData.data;
    const rgb = hexToRgb(color);

    for (let index = 0; index < pixels.length; index += 4) {
      const red = pixels[index];
      const green = pixels[index + 1];
      const blue = pixels[index + 2];
      const originalAlpha = pixels[index + 3];

      /*
       * Helle Bildbereiche werden transparent.
       * Dunkle Symbolbereiche erhalten die gewählte Schriftfarbe.
       */
      const brightness =
        red * 0.299 +
        green * 0.587 +
        blue * 0.114;

      const symbolAlpha = Math.max(
        0,
        Math.min(255, 255 - brightness)
      );

      pixels[index] = rgb.r;
      pixels[index + 1] = rgb.g;
      pixels[index + 2] = rgb.b;
      pixels[index + 3] =
        (symbolAlpha * originalAlpha) / 255;
    }

    context.putImageData(imageData, 0, 0);
  };

  sourceImage.onerror = function () {
    console.warn(
      "Monello Vorschau: Symbol konnte nicht geladen werden:",
      symbol.src
    );
  };

  return canvas;
}

function updatePreview() {
  const fields = getFields();
  const elements = getPreviewElements();

  /*
   * Der HTML-Bereich wird von Globo nur dann angezeigt,
   * wenn die Personalisierung ausgewählt wurde.
   */
if (
  !elements.preview ||
  !elements.name ||
  !elements.date ||
  !elements.text
) {
  return;
}

  const name = fields.name?.value?.trim() || "";
  const date = fields.date?.value?.trim() || "";
  const text = fields.text?.value?.trim() || "";
  const symbols = getSelectedSymbols();
  const { font, color } = detectFontAndColor();

  elements.name.textContent =
    name || "Name deines Lieblings";

  elements.name.classList.toggle(
    "is-placeholder",
    !name
  );

  elements.date.textContent = date;
  elements.text.textContent = text;

  /*
   * Ausgewählte Originalsymbole erzeugen und einfärben.
   */
  if (elements.symbols) {
    elements.symbols.innerHTML = "";

    symbols.forEach((symbol) => {
      if (symbol.type !== "image") return;

      const coloredSymbol = createColoredSymbol(
        symbol,
        color
      );

      elements.symbols.appendChild(coloredSymbol);
    });

    elements.symbols.style.display =
      symbols.length > 0 ? "flex" : "none";
  }

  /*
   * Schriftgröße automatisch an die Textlänge anpassen.
   */
  function getResponsiveFontSize(value, sizes) {
    const length = value.trim().length;

    if (length <= sizes.short.max) {
      return sizes.short.size;
    }

    if (length <= sizes.medium.max) {
      return sizes.medium.size;
    }

    if (length <= sizes.long.max) {
      return sizes.long.size;
    }

    return sizes.extraLong.size;
  }

  elements.name.style.fontSize = getResponsiveFontSize(name, {
    short: {
      max: 10,
      size: "38px"
    },
    medium: {
      max: 18,
      size: "32px"
    },
    long: {
      max: 28,
      size: "26px"
    },
    extraLong: {
      size: "22px"
    }
  });

  elements.date.style.fontSize = getResponsiveFontSize(date, {
    short: {
      max: 22,
      size: "18px"
    },
    medium: {
      max: 32,
      size: "16px"
    },
    long: {
      max: 45,
      size: "14px"
    },
    extraLong: {
      size: "13px"
    }
  });

  elements.text.style.fontSize = getResponsiveFontSize(text, {
    short: {
      max: 24,
      size: "24px"
    },
    medium: {
      max: 40,
      size: "21px"
    },
    long: {
      max: 60,
      size: "18px"
    },
    extraLong: {
      size: "16px"
    }
  });

  /*
   * Schriftart und Schriftfarbe auf die Texte anwenden.
   */
  [
    elements.name,
    elements.date,
    elements.text
  ].forEach((element) => {
    if (!element) return;

    element.style.fontFamily = font;
    element.style.color = color;
  });

  /*
   * Für weiße Schrift wird der Vorschauhintergrund dunkel.
   */
  if (elements.card) {
    elements.card.style.background =
      color === "#ffffff"
        ? "linear-gradient(135deg, #625650, #2f2925)"
        : "#ffffff";
  }
}

function movePreview() {
  /*
   * Die Vorschau befindet sich jetzt direkt im bedingten
   * Globo-HTML-Bereich und darf nicht mehr verschoben werden.
   */
}

  function initialize() {
  movePreview();

  const fields = getFields();
  initCharacterCounter(fields.text);

  updatePreview();
}

  document.addEventListener("input", updatePreview);
  document.addEventListener("change", updatePreview);

  document.addEventListener("click", () => {
    window.setTimeout(updatePreview, 120);
  });

  document.addEventListener("DOMContentLoaded", initialize);

  [300, 800, 1500, 3000].forEach((delay) => {
    window.setTimeout(initialize, delay);
  });
})();